import { format } from 'date-fns'
import Parse from 'parse'

const state = {
  today: format(new Date(), 'YYYYMMDD'),
  info: null,
  infos: []
}

const getters = {
  info: (state, getters, rootState, rootGetters) => (info) => {
    return rootGetters['text/trim'](info.get('content'))
  },

  date: (state) => (info) => {
    const date = info.get('createdAt')
    if (state.today === format(date, 'YYYYMMDD')) {
      return format(date, 'H:m')
    }
    return format(date, 'M月D日')
  }
}

const mutations = {
  setInfo (state, info) {
    state.info = info
  },

  setInfos (state, infos) {
    state.infos = infos
  }
}

const actions = {
  async retrieveInfos ({ commit }) {
    const query = new Parse.Query('Info')
    query.descending('createdAt')
    commit('setInfos', await query.find())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
